(function () {
  'use strict';

  if (window.PeVeoCommerce) return;

  var normalize = function (value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase('nb-NO')
      .trim();
  };

  var formatMoney = function (cents, currency) {
    var amount = Number(cents || 0) / 100;
    var hasDecimals = Math.round(amount) !== amount;

    try {
      return new Intl.NumberFormat('nb-NO', {
        style: 'currency',
        currency: currency || 'NOK',
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return amount.toFixed(hasDecimals ? 2 : 0).replace('.', ',') + ' kr';
    }
  };

  var initCollection = function (root) {
    if (!root || root.dataset.peveoInitialized === 'true') return;
    root.dataset.peveoInitialized = 'true';
    root.dataset.peveoEnhanced = 'true';

    var searchInput = root.querySelector('[data-peveo-product-search]');
    var filterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-peveo-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-peveo-product-card]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-peveo-product-group]'));
    var count = root.querySelector('[data-peveo-result-count]');
    var emptyState = root.querySelector('[data-peveo-empty-state]');
    var resetButton = root.querySelector('[data-peveo-filter-reset]');
    var activeCategory = 'alle';

    if (!searchInput || cards.length === 0) return;

    var applyFilters = function () {
      var query = normalize(searchInput.value);
      var visibleCount = 0;

      cards.forEach(function (card) {
        var matchesCategory = activeCategory === 'alle' || card.dataset.category === activeCategory;
        var matchesSearch = !query || normalize(card.dataset.search).indexOf(query) !== -1;
        var visible = matchesCategory && matchesSearch;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      groups.forEach(function (group) {
        var visibleCards = group.querySelectorAll('[data-peveo-product-card]:not([hidden])').length;
        group.hidden = visibleCards === 0;
      });

      if (count) count.textContent = String(visibleCount);
      if (emptyState) emptyState.hidden = visibleCount !== 0;
    };

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeCategory = button.dataset.peveoFilter || 'alle';
        filterButtons.forEach(function (candidate) {
          candidate.setAttribute('aria-pressed', candidate === button ? 'true' : 'false');
        });
        applyFilters();
      });
    });

    searchInput.addEventListener('input', applyFilters);

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        activeCategory = 'alle';
        searchInput.value = '';
        filterButtons.forEach(function (candidate) {
          candidate.setAttribute('aria-pressed', candidate.dataset.peveoFilter === 'alle' ? 'true' : 'false');
        });
        applyFilters();
        searchInput.focus();
      });
    }

    applyFilters();
  };

  var initProduct = function (root) {
    if (!root || root.dataset.peveoInitialized === 'true') return;
    root.dataset.peveoInitialized = 'true';
    root.dataset.peveoEnhanced = 'true';

    var variantsElement = root.querySelector('[data-peveo-variants]');
    var variants = [];

    if (variantsElement) {
      try {
        variants = JSON.parse(variantsElement.textContent || '[]');
      } catch (error) {
        variants = [];
      }
    }

    var variantSelect = root.querySelector('[data-peveo-variant-select]');
    var variantInput = root.querySelector('[data-peveo-variant-input]');
    var price = root.querySelector('[data-peveo-price]');
    var comparePrice = root.querySelector('[data-peveo-compare-price]');
    var stock = root.querySelector('[data-peveo-stock]');
    var stockLabel = root.querySelector('[data-peveo-stock-label]');
    var addButton = root.querySelector('[data-peveo-add-button]');
    var addLabel = root.querySelector('[data-peveo-add-label]');
    var mobileLabel = root.querySelector('[data-peveo-mobile-label]');
    var mobileButton = root.querySelector('[data-peveo-mobile-buybar-button]');
    var currency = root.dataset.currency || 'NOK';
    var commerceState = root.dataset.commerceState || 'available';

    var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-peveo-media]'));
    var thumbnails = Array.prototype.slice.call(root.querySelectorAll('[data-peveo-thumbnail]'));

    var showMedia = function (mediaId) {
      if (!mediaId) return;
      var normalizedId = String(mediaId);

      mediaItems.forEach(function (item) {
        var active = item.dataset.peveoMedia === normalizedId;
        item.hidden = !active;
        item.dataset.active = active ? 'true' : 'false';
      });

      thumbnails.forEach(function (thumbnail) {
        thumbnail.setAttribute('aria-current', thumbnail.dataset.peveoThumbnail === normalizedId ? 'true' : 'false');
      });
    };

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        showMedia(thumbnail.dataset.peveoThumbnail);
      });
    });

    var currentVariant = function () {
      var id = variantSelect ? variantSelect.value : variantInput ? variantInput.value : '';
      return variants.find(function (variant) {
        return String(variant.id) === String(id);
      });
    };

    var updateVariant = function () {
      var variant = currentVariant();
      if (!variant) return;

      var available = Boolean(variant.available);
      var variantPrice = Number(variant.price || 0);
      var variantComparePrice = Number(variant.compare_at_price || 0);
      var fixedNonPurchasableState = commerceState === 'unavailable' || commerceState === 'coming_soon';

      if (price && !fixedNonPurchasableState) price.textContent = formatMoney(variantPrice, currency);

      if (comparePrice && !fixedNonPurchasableState) {
        var showComparePrice = variantComparePrice > variantPrice;
        comparePrice.hidden = !showComparePrice;
        comparePrice.textContent = showComparePrice ? formatMoney(variantComparePrice, currency) : '';
      }

      if (stock && !fixedNonPurchasableState) {
        stock.dataset.available = available ? 'true' : 'false';
        var hasInventoryData = Object.prototype.hasOwnProperty.call(variant, 'inventory_quantity') ||
          Object.prototype.hasOwnProperty.call(variant, 'inventory_policy');

        if (available && hasInventoryData) {
          var inventory = Number(variant.inventory_quantity);
          var lowStockThreshold = Number(root.dataset.lowStockThreshold || 0);
          var lowStock = Number.isFinite(inventory) && inventory > 0 && inventory <= lowStockThreshold;
          var isBackorder = variant.inventory_policy === 'continue' && inventory <= 0;

          if (lowStock) {
            (stockLabel || stock).textContent = (root.dataset.lowStockLabel || 'Bare [count] på lager').replace('[count]', String(inventory));
          } else if (isBackorder) {
            (stockLabel || stock).textContent = root.dataset.backorderLabel || root.dataset.inStockLabel || 'Kan bestilles';
          } else {
            (stockLabel || stock).textContent = root.dataset.inStockLabel || 'På lager';
          }
        } else if (!available) {
          (stockLabel || stock).textContent = root.dataset.outOfStockLabel || root.dataset.soldOutLabel || 'Utsolgt';
        }
      }

      if (addButton && !fixedNonPurchasableState) addButton.disabled = !available;
      if (addLabel && !fixedNonPurchasableState) addLabel.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
      if (mobileButton && !fixedNonPurchasableState) mobileButton.disabled = !available;
      if (mobileLabel && !fixedNonPurchasableState) {
        mobileLabel.textContent = available
          ? (root.dataset.mobileAddLabel || root.dataset.addLabel) + ' – ' + formatMoney(variantPrice, currency)
          : root.dataset.soldOutLabel;
      }

      if (root.dataset.featuredMediaOnly !== 'true') {
        var featuredMedia = variant.featured_media || variant.featured_image;
        if (featuredMedia && featuredMedia.id) showMedia(featuredMedia.id);
      }
    };

    if (variantSelect) variantSelect.addEventListener('change', updateVariant);

    var quantity = root.querySelector('[data-peveo-quantity]');
    Array.prototype.slice.call(root.querySelectorAll('[data-peveo-quantity-change]')).forEach(function (button) {
      button.addEventListener('click', function () {
        if (!quantity) return;
        var nextValue = Math.max(1, Number(quantity.value || 1) + Number(button.dataset.peveoQuantityChange || 0));
        quantity.value = String(nextValue);
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    if (quantity) {
      quantity.addEventListener('change', function () {
        quantity.value = String(Math.max(1, Math.floor(Number(quantity.value || 1))));
      });
    }

    var buyPanel = root.querySelector('[data-peveo-buy-panel]');
    var mobileBar = root.querySelector('[data-peveo-mobile-buybar]');
    var framePending = false;

    var updateMobileBar = function () {
      framePending = false;
      if (!mobileBar || !buyPanel) return;

      var bounds = buyPanel.getBoundingClientRect();
      var inView = bounds.top < window.innerHeight * 0.85 && bounds.bottom > 0;
      var visible = window.scrollY > 280 && !inView;
      mobileBar.dataset.visible = visible ? 'true' : 'false';
      mobileBar.setAttribute('aria-hidden', visible ? 'false' : 'true');

      if (mobileButton) mobileButton.tabIndex = visible ? 0 : -1;
    };

    var requestMobileBarUpdate = function () {
      if (framePending) return;
      framePending = true;
      window.requestAnimationFrame(updateMobileBar);
    };

    if (mobileButton && buyPanel) {
      mobileButton.addEventListener('click', function () {
        buyPanel.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center'
        });
      });
    }

    window.addEventListener('scroll', requestMobileBarUpdate, { passive: true });
    window.addEventListener('resize', requestMobileBarUpdate, { passive: true });

    updateVariant();
    updateMobileBar();
  };

  var scan = function (scope) {
    var context = scope || document;
    Array.prototype.slice.call(context.querySelectorAll('[data-peveo-collection]')).forEach(initCollection);
    Array.prototype.slice.call(context.querySelectorAll('[data-peveo-product]')).forEach(initProduct);

    if (context.matches && context.matches('[data-peveo-collection]')) initCollection(context);
    if (context.matches && context.matches('[data-peveo-product]')) initProduct(context);
  };

  window.PeVeoCommerce = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
